var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-step-form"},[_c('el-steps',{attrs:{"space":200,"active":1,"simple":""}},[_c('el-step',{attrs:{"title":"填写转账信息","icon":"el-icon-edit"}}),_c('el-step',{attrs:{"title":"确认转账信息","icon":"el-icon-view"}}),_c('el-step',{attrs:{"title":"完成","icon":"el-icon-check"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }